import React, { useState, useEffect } from 'react';
import cn from 'classnames';

import BurgerMenuItem from './BurgerMenuItem';
import { pushMenuOpen } from 'js/helpers/gtm';
import {sanitizeContent} from 'js/shared/security';
import './burgerMenu.scss';

const getPageNameGA4 = () => window?.drupalSettings?.g4DataLayerCommonVariables?.pagename;

const BurgerMenu = ({
  menuDataLeft,
  menuDataRight,
  destinationsMenu,
  corporateMenu,
  homeUrl,
  backButtonLabel,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLevel, setActiveLevel] = useState('first'); // 'first', 'second', 'third'
  const [activeSecondLevelTitle, setActiveSecondLevelTitle] = useState('');
  const [activeThirdLevelTitle, setActiveThirdLevelTitle] = useState('');

  const [drupalData, setDrupalData] = useState({
    lang: null, langHTML: '', currency: null, currencyTitle: '', currencyHTML: ''
  });

  useEffect(() => {
    const lang = document.querySelector('.menu-item-cash_lang .current-state');
    const currency = document.querySelector('.menu-item-cash .current-currency');
    const switchers = document.querySelector('.switchers');

    if (lang && currency) {
      setDrupalData({
        lang,
        langHTML: lang.innerHTML,
        currency,
        currencyTitle: switchers?.dataset?.title || '',
        currencyHTML: currency.innerHTML,
      });
    }
  }, []);

  const toggleMenuOpen = () => {
    const nextState = !menuOpen;
    setMenuOpen(nextState);
    document.body.classList.toggle('menu-opened', nextState);
    setActiveLevel('first');

    if (nextState) {
      pushMenuOpen(getPageNameGA4());
    }
  };

  const levelsHandler = (level) => setActiveLevel(level);

  const backBtnHandler = () => {
    if (activeLevel === 'second') {
      setActiveLevel('first');
      setActiveSecondLevelTitle('');
    } else if (activeLevel === 'third') {
      setActiveLevel('second');
      setActiveThirdLevelTitle('');
    }
  };

  const fakeCall = (type) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    drupalData[type]?.click();
  };

  const allMenuItems = { destinationsKey: { ...destinationsMenu }, ...menuDataLeft, ...menuDataRight, ...corporateMenu };

  return (
    <div className="mobile-menu">
      <div className={cn('mobile-menu__btn', { 'open': menuOpen })} onClick={toggleMenuOpen}>
        <span></span><span></span><span></span>
      </div>

      {menuOpen && (
        <div className="mobile-menu__container">
          <div className="mobile-menu__breadcrumbs">
            <span className="mobile-menu__breadcrumbs-item">
              <a href={homeUrl}>Home</a>
            </span>
            {(activeLevel === 'second' || activeLevel === 'third') && (
              <span className="mobile-menu__breadcrumbs-item" onClick={() => levelsHandler('second')}>
                {activeSecondLevelTitle}
              </span>
            )}
            {activeLevel === 'third' && (
              <span className="mobile-menu__breadcrumbs-item">{activeThirdLevelTitle}</span>
            )}
          </div>

          <div className="mobile-menu__scroll-wrapper">
            <div className={cn('mobile-menu__levels-wrapper', activeLevel)}>
              <div className={cn('mobile-menu__first-level', { 'active': activeLevel === 'first' })}>
                {Object.keys(allMenuItems).map((key) => (
                  <BurgerMenuItem
                    {...allMenuItems[key]}
                    key={key}
                    activeLevel={activeLevel}
                    levelsHandler={levelsHandler}
                    backBtnHandler={backBtnHandler}
                    setSecondLevelTitle={setActiveSecondLevelTitle}
                    setThirdLevelTitle={setActiveThirdLevelTitle}
                    backButtonLabel={backButtonLabel}
                  />
                ))}

                {drupalData.lang && (
                  <div className="mobile-menu__switchers">
                    <div className="mobile-menu__switchers-title">{drupalData.currencyTitle}</div>
                    <div className="mobile-menu__switchers-item"
                         onClick={fakeCall('lang')}
                         dangerouslySetInnerHTML={{ __html: sanitizeContent(drupalData.langHTML) }} />
                    <div className="mobile-menu__switchers-item mobile-menu__switchers-item_currency"
                         onClick={fakeCall('currency')}
                         dangerouslySetInnerHTML={{ __html: sanitizeContent(drupalData.currencyHTML) }} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BurgerMenu;
